import type { JSX } from "react";
import { useObservable } from "ecce-react";
import { useServices } from "../../../services/services-context";
import { NotificationView } from "./notification-view";



export const NotificationArea = (): JSX.Element => {
	const { notification } = useServices();
	useObservable(notification.notifications);

	return (
		<div aria-live="polite">
			{ notification.notifications.map(notification => (
				<NotificationView
					notification={ notification }
					key={ notification.id }
				/>
			)) }
		</div>
	);
};